import { axios } from '../shared/axiosClient';
import { AxiosErrorHandler } from '../shared/Helpers';
import { FMVMiner } from '../types/generative_ai';

export const retrieveFMVMinerData = async (payload: FMVMiner): Promise<any> => {
  try {
    const res = await axios.post(`/api/ai/fmvMiner`, payload);
    if (res.data?.status === 'success') {
      return res.data.data;
    }
    return Promise.reject(Error(res?.data?.message));
  } catch (e) {
    AxiosErrorHandler(e);
    throw e;
  }
};
